module.exports = __webpack_public_path__ + "static/media/duomo.086810df.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/duomo.svg
// module id = 294
// module chunks = 12